import { Control } from "ol/control";
import colorRepository from "./colors-repository";

/**
 * A sliding, better-looking legend control.
 */
export class LegendControl extends Control {
  constructor() {
    const container = document.createElement("div");
    container.className = "ol-unselectable ol-control legend-container";

    super({ element: container });

    this.isOpen = false; // Track if the legend is open

    this.createLegend(container);
  }

  createLegend(container) {
    // Sidebar Toggle Button
    const toggleButton = document.createElement("button");
    toggleButton.className = "legend-toggle";
    toggleButton.style.backgroundColor = "#7f9dc3";
    toggleButton.style.borderRadius = "50% 0 0 50%"; // Semi-circle on the left
    toggleButton.style.padding = "1rem"; // Make it bigger
    toggleButton.innerHTML = `
    <svg width="22px" height="22px" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" class="iconify iconify--gis" preserveAspectRatio="xMidYMid meet">
        <path d="M12.467 5.087a2.084 2.084 0 0 0-1.772 1.041L.28 24.171a2.084 2.084 0 0 0 1.805 3.125h20.834a2.084 2.084 0 0 0 1.803-3.125L14.305 6.128a2.084 2.084 0 0 0-1.838-1.04zm.033 6.25l6.807 11.791H5.69zM40 14.485v7h15v-7zm22 0v7h38v-7zM2.084 39.671A2.084 2.084 0 0 0 0 41.755v16.666a2.084 2.084 0 0 0 2.084 2.084h20.832A2.084 2.084 0 0 0 25 58.421V41.755a2.084 2.084 0 0 0-2.084-2.084zm2.082 4.168h16.668v12.5H4.166zM40 47.837v7h27v-7zm34 0v7h26v-7zM12.5 69.913c-6.879 0-12.5 5.621-12.5 12.5c0 6.88 5.621 12.5 12.5 12.5s12.5-5.62 12.5-12.5c0-6.879-5.621-12.5-12.5-12.5zm0 4.166a8.303 8.303 0 0 1 8.334 8.334a8.303 8.303 0 0 1-8.334 8.334a8.303 8.303 0 0 1-8.334-8.334A8.303 8.303 0 0 1 12.5 74.08zM40 81.19v7h15v-7zm22 0v7h38v-7z" fill="#FFFFFF" fill-rule="evenodd" stroke="#FFFFFF" stroke-width="2"></path>
    </svg>`;

	const svg = toggleButton.querySelector("svg");
	svg.style.transform = "translate(-10px, -12px)";

	container.append(toggleButton);

    // Legend Content
    const legendContent = document.createElement("div");
    legendContent.className = "legend-content";
    container.append(legendContent);

    // Add Sections to the Legend
    this.addActivitySection(legendContent);
    this.addOffsetSection(legendContent);

    // Event Listeners
    toggleButton.addEventListener("click", () => this.toggleLegend());
  }

  toggleLegend() {
    this.isOpen = !this.isOpen;
    this.element.classList.toggle("legend-open", this.isOpen);

    // Update the toggle button direction
    const toggleButton = this.element.querySelector(".legend-toggle");
  }

  addActivitySection(container) {
    const section = document.createElement("section");
    section.className = "legend-section";

    const header = document.createElement("strong");
    header.textContent = "Stopnja aktivnosti plazljivih območij";
    section.append(header);

    const levels = [
      { color: colorRepository.activityLevel.none, text: "Nezaznavna aktivnost" },
      { color: colorRepository.activityLevel.low, text: "Nizka aktivnost" },
      { color: colorRepository.activityLevel.medium, text: "Srednja aktivnost" },
      { color: colorRepository.activityLevel.high, text: "Visoka aktivnost" },
    ];

    levels.forEach(({ color, text }) => {
      const row = document.createElement("div");
      row.className = "legend-row";

      const colorBox = document.createElement("span");
      colorBox.className = "color-box";
      colorBox.style.backgroundColor = color;

      const label = document.createElement("span");
      label.textContent = text;

      row.append(colorBox, label);
      section.append(row);
    });

    container.append(section);
  }

  addOffsetSection(container) {
    const section = document.createElement("section");
    section.className = "legend-section";

    const header = document.createElement("strong");
    header.textContent = "Hitrost premikov";
    section.append(header);

    const gradient = document.createElement("div");
    gradient.className = "legend-gradient";
    gradient.style.background = `linear-gradient(to right, ${colorRepository.pointOffset.join(", ")})`;
    section.append(gradient);

    const values = document.createElement("div");
    values.className = "legend-values";

    const minValue = document.createElement("span");
    minValue.textContent = "-20.5";

    const unit = document.createElement("span");
    unit.textContent = "(mm/leto)";

    const maxValue = document.createElement("span");
    maxValue.textContent = "20.5";

    values.append(minValue, unit, maxValue);
    section.append(values);

    container.append(section);
  }
}
